import {LngLat, LngLatBounds} from '@logistics-frontend/blocks'
import {Point} from '@logistics-frontend/core/types'
import {SuggestObject} from '@yandex-taxi/js-integration-api'

export const getPlacemarkCoords = (addressValue: SuggestObject) =>
  addressValue.pos.split(',').map(val => parseFloat(val)) as Point

export const lngLatsToBounds = (lngLats: LngLat[]): LngLatBounds | undefined => {
  if (lngLats.length === 0) {
    return undefined
  }
  const nonNormalizedBounds = lngLats.reduce<LngLatBounds>(
    (acc, [longitude, latitude]) => [
      [Math.min(acc[0][0], longitude!), Math.max(acc[0][1], latitude!), 0.5],
      [Math.max(acc[1][0], longitude!), Math.min(acc[1][1], latitude!), 0.5],
    ],
    [
      //top      left
      [Infinity, -Infinity],
      //bottom   right
      [-Infinity, Infinity],
    ],
  )
  const lngAmplitude = nonNormalizedBounds[1][0] - nonNormalizedBounds[0][0]
  const latAmplitude = nonNormalizedBounds[0][1] - nonNormalizedBounds[1][1]
  const k = 0.2
  return [
    [nonNormalizedBounds[0][0] - k * lngAmplitude, nonNormalizedBounds[0][1] + k * latAmplitude],
    [nonNormalizedBounds[1][0] + k * lngAmplitude, nonNormalizedBounds[1][1] - k * latAmplitude],
  ]
}
